<template lang="pug">
.uncertain-order-assign
  el-table(:data="[toAssignSpu]")
    el-table-column(label="商品" align="left" min-width="120px")
      template(slot-scope="scope")
        div {{ scope.row.itemTitle }}
        div 商品编号：{{ scope.row.itemId }}
        div(v-if="scope.row.supplierName") {{scope.row.supplierName}}
        //- div 仓库：{{ scope.row.warehouseName }}
    el-table-column(label="商品属性" align="center" min-width="90px")
      template(slot-scope="scope")
        .c-9
          p.sku-title 单件重:
            span.c-3 {{scope.row.pieceWeight / 10000}}{{ scope.row.pieceWeightUnit | formatWeightUnit}}
          p(v-for="(prop, index) in scope.row.spuProps" :key="index")
            span {{ prop.key }}：
            span.c-3 {{ prop.value }}
          p.sku-title 仓库:
            span.c-3 {{ scope.row.warehouseName }}
    el-table-column(label="单价" align="center")
      template(slot-scope="scope")
        template(v-if="scope.row.logisticsPrice || scope.row.processFee || scope.row.storageFee|| scope.row.commissionFee||scope.row.promiseInterestSubsidyFee || scope.row.settleAdjustFee")
          p {{ (scope.row.itemPrice + scope.row.logisticsPrice + (scope.row.processFee  || 0) + (scope.row.storageFee || 0) + (scope.row.commissionFee || 0) + (scope.row.promiseInterestSubsidyFee || 0) + (scope.row.settleAdjustFee || 0)) / 100 }} 元/{{ scope.row.pieceWeightUnit | formatWeightUnit }}
            zg-info
              div(slot="content")
                div 商品单价：{{ scope.row.itemPrice / 100 }} 元/{{ scope.row.pieceWeightUnit | formatWeightUnit }}
                div(v-if='scope.row.logisticsPrice') 胖猫物流费：{{ scope.row.logisticsPrice / 100 }} 元/{{ scope.row.pieceWeightUnit | formatWeightUnit }}
                div(v-if='scope.row.processFee') 加工费：{{ scope.row.processFee / 100 }} 元/{{ scope.row.pieceWeightUnit | formatWeightUnit }}
                div(v-if='scope.row.storageFee') 仓储费：{{ scope.row.storageFee / 100 }} 元/{{ scope.row.pieceWeightUnit | formatWeightUnit }}
                div(v-if='scope.row.commissionFee') 委托物流费：{{ scope.row.commissionFee / 100 }} 元/{{ scope.row.pieceWeightUnit | formatWeightUnit }}
                div(v-if='scope.row.promiseInterestSubsidyFee') 承兑贴息费：{{ scope.row.promiseInterestSubsidyFee / 100 }} 元/{{ scope.row.pieceWeightUnit | formatWeightUnit }}
                div(v-if='scope.row.settleAdjustFee') 结算调差费：{{ scope.row.settleAdjustFee / 100 }} 元/{{ scope.row.pieceWeightUnit | formatWeightUnit }}

        template(v-else)
          p {{ scope.row.itemPrice / 100 }} 元/{{ scope.row.pieceWeightUnit | formatWeightUnit }}

    //- el-table-column(label="单件重" align="center")
    //-   template(slot-scope="scope")
    //-     p {{ scope.row.pieceWeight / 10000 }} {{ scope.row.pieceWeightUnit | formatWeightUnit }}
    el-table-column(label="数量" align="center" prop="buyAmount")
    el-table-column(label="重量" align="center")
      template(slot-scope="scope")
        p {{ scope.row.totalWeight / 10000 }}{{ scope.row.pieceWeightUnit | formatWeightUnit }}
    el-table-column(label="小计金额" align="center")
      template(slot-scope="scope")
        p(v-if="scope.row.isShowActualTotalFee")
          template(v-if="scope.row.logisticsTotalFee || scope.row.processTotalFee || scope.row.storageTotalFee || scope.row.commissionTotalFee || scope.row.promiseInterestSubsidyTotalFee || scope.row.settleAdjustTotalFee")
            p {{ scope.row.actualTotalFee | currencyFormat }}
              zg-info
                div(slot="content")
                  div 商品小计：{{ scope.row.obligationTotalFee | currencyFormat }}
                  div(v-if='scope.row.logisticsTotalFee') 胖猫物流金额：{{ scope.row.logisticsTotalFee | currencyFormat }}
                  div(v-if='scope.row.processTotalFee') 加工费金额：{{ scope.row.processTotalFee | currencyFormat }}
                  div(v-if='scope.row.storageTotalFee') 仓储费金额：{{ scope.row.storageTotalFee | currencyFormat }}
                  div(v-if='scope.row.commissionTotalFee') 委托物流费金额：{{ scope.row.commissionTotalFee | currencyFormat }}
                  div(v-if='scope.row.promiseInterestSubsidyTotalFee') 承兑贴息金额：{{ scope.row.promiseInterestSubsidyTotalFee | currencyFormat }}
                  div(v-if='scope.row.settleAdjustTotalFee') 结算调差金额：{{ scope.row.settleAdjustTotalFee | currencyFormat }}

          template(v-else)
            p {{ scope.row.actualTotalFee | currencyFormat }}
    el-table-column(label="待指认量" align="center")
      template(slot-scope="scope")
        p {{ scope.row.assignWeightAmount / 10000 }}{{ scope.row.pieceWeightUnit | formatWeightUnit }}
    //- el-table-column(label="待指认金额" align="center")
    //-   template(slot-scope="scope")
    //-     p(v-if="scope.row.isShowActualTotalFee") {{ scope.row.assignMoneyAmount | currencyFormat}}
  div.f-b.m-t20 指认商品明细
    el-select.fees-select(v-if='getIsMerchantDelivery' v-model='fees' multiple placeholder='请选择' collapse-tags @change='handleSelectChange')
      el-option(v-for='item in options'
              :key='item.value'
              :label = 'item.label'
              :value='item.value'
            )
  el-table.m-t10(:data="assignSkus")
    el-table-column(label="品名" align="left" min-width='150')
      template(slot-scope="scope")
        el-select(v-model="scope.row.categoryId" :disabled="getDisableEdit" class="full-width")
          el-option(v-for="c in categoryList" :key="c.id" :label="c.name" :value="c.id")
    el-table-column(label="材质" align="left" min-width='120')
      template(slot-scope="scope")
        el-autocomplete(v-model.trim="scope.row.skuMaterial" :fetch-suggestions="(str,cb)=>handleMaterialSearch(str,cb,scope.row)" :disabled="getDisableEdit")
    el-table-column(label="规格" align="center" min-width='150')
      template(slot-scope="scope")
        el-input(v-model="scope.row.skuSpecification" :disabled="getDisableEdit")
    el-table-column(label="钢厂" align="center" min-width="100")
      template(slot-scope="scope")
        el-input(v-model="scope.row.steelMill" :disabled="getDisableEdit")
    el-table-column(label="商品单价（元/吨）" align="center" min-width='150')
      template(slot-scope="scope")
        el-input(v-model="scope.row.itemSkuPrice" :disabled="getDisableEdit"
          @input="inputGetNumber(scope.$index, 'itemSkuPrice', 2)")
    el-table-column(v-if="getIsMerchantDelivery && fees.includes('logisticsPrice')" label="胖猫物流费(元/吨)" align="center" min-width='120')
      template(slot-scope="scope")
        el-input(v-model="scope.row.logisticsPrice" :disabled="getDisableEdit"
          @input="inputGetNumber(scope.$index, 'logisticsPrice', 2)")
    el-table-column(v-if="getIsMerchantDelivery && fees.includes('processFee')" label="加工费" align="center" min-width='100')
      template(slot-scope="scope")
        el-input(v-model="scope.row.processFee" :disabled="getDisableEdit"
          @input="inputGetNumber(scope.$index, 'processFee', 2)")
    el-table-column(v-if="getIsMerchantDelivery && fees.includes('storageFee')" label="仓储费" align="center" min-width='100')
      template(slot-scope="scope")
        el-input(v-model="scope.row.storageFee" :disabled="getDisableEdit"
          @input="inputGetNumber(scope.$index, 'storageFee', 2)")
    el-table-column(v-if="getIsMerchantDelivery && fees.includes('commissionFee')" label="委托物流费" align="center" min-width='100')
      template(slot-scope="scope")
        el-input(v-model="scope.row.commissionFee" :disabled="getDisableEdit"
          @input="inputGetNumber(scope.$index, 'commissionFee', 2)")
    el-table-column(v-if="getIsMerchantDelivery && fees.includes('promiseInterestSubsidyFee')" label="承兑贴息费" align="center" min-width='100')
      template(slot-scope="scope")
        el-input(v-model="scope.row.promiseInterestSubsidyFee" :disabled="getDisableEdit"
          @input="inputGetNumber(scope.$index, 'promiseInterestSubsidyFee', 2)")
    el-table-column(v-if="getIsMerchantDelivery && fees.includes('settleAdjustFee')" label="结算调差费" align="center" min-width='100')
      template(slot-scope="scope")
        el-input(v-model="scope.row.settleAdjustFee" :disabled="getDisableEdit"
          @input="inputGetNumber(scope.$index, 'settleAdjustFee', 2)")
    el-table-column(label="计量方式" align="center" min-width="100")
      template(slot-scope="scope")
        el-select(v-model="scope.row.valuationUnitWay" :disabled="getDisableEdit")
          el-option(v-for="o in optionsValuationUnitWay" :key="o.value" :label="o.label" :value="o.value")
    el-table-column(label="捆包号" align="center" min-width="100")
      template(slot-scope="scope")
        el-input(v-model="scope.row.bundleNo" :disabled="getDisableEdit")
    el-table-column(label="单件重（吨）" align="center" min-width="110")
      template(slot-scope="scope")
        el-input(v-model="scope.row.pieceWeight" :disabled="getDisableEdit"
          @input="inputGetNumber(scope.$index, 'pieceWeight', 3)")
    el-table-column(label="数量" align="center" min-width="80")
      template(slot-scope="scope")
        el-input(v-model="scope.row.buyNum" width="150px"
          @input="inputGetNumber(scope.$index, 'buyNum')")
    el-table-column(label="重量/小计" align="center" type="number" min="0" min-width='100')
      template(slot-scope="scope")
        template(v-if="scope.row.pieceWeight && scope.row.buyNum")
          p {{ times(scope.row.pieceWeight, scope.row.buyNum) }}吨
        //- 必填项填写完整计算总金额
        template(v-if="scope.row.itemSkuPrice && scope.row.pieceWeight && scope.row.buyNum")
          p {{ times(plus(scope.row.itemSkuPrice * 1, scope.row.logisticsPrice * 1), scope.row.pieceWeight, scope.row.buyNum) }}元
    el-table-column(label="操作" v-if="mode === 'add'" align="center" min-width="68")
      template(slot-scope="scope")
        div.operation-list
          span.icon
            svg-icon(icon-class="add" @click="copy(scope.row)")
          //- 已提货不能删除
          span.icon(v-if="assignSkus.length > 1")
            svg-icon(icon-class="delete" @click="del(scope.$index)")

  div.c-6.m-t20.text-right
    span 指认小计：
    span.c-3.m-l10 数量 {{ getTotal.num }}
    span.c-3.m-l10(:class="{'c-red': getIsOverWeight  }") {{ getTotal.weight }}
    span.m-l5 吨
    span.c-3.m-l15(:class="{'c-red': getIsOverPrice  }") {{ getTotal.price * 100 | currencyFormat }}

  div.text-right.m-t20
    el-button(@click="leave").btn 取消
    el-button(type="primary" @click="assign").btn 确认
</template>

<script>
import NP from 'number-precision'
import ZgInfo from '@/components/zg-info'
export default {
  name: 'UncertainOrderAssign',
  components: {
    ZgInfo
  },
  props: {
    mode: {
      type: String
    },
    toAssignSpu: {
      type: Object
    },
    toEditSku: {
      type: Object
    },
    subOrderId: {
      type: Number
    }
  },
  data() {
    return {
      // 计量方式的 options
      optionsValuationUnitWay: [
        {
          label: '理计',
          value: 1
        },
        {
          label: '过磅',
          value: 2
        },
        {
          label: '抄码',
          value: 3
        }
      ],
      categoryList: [],
      assignSkus: [],
      options: [
        {
          value: 'logisticsPrice',
          label: '胖猫物流费'
        },
        {
          value: 'processFee',
          label: '加工费'
        },
        {
          value: 'storageFee',
          label: '仓储费'
        },
        {
          value: 'commissionFee',
          label: '委托物流费'
        },
        {
          value: 'promiseInterestSubsidyFee',
          label: '承兑贴息费'
        },
        {
          value: 'settleAdjustFee',
          label: '结算调差费'
        }
      ],
      fees: [],
      feesAll: [
        'processFee',
        'storageFee',
        'logisticsPrice',
        'commissionFee',
        'promiseInterestSubsidyFee',
        'settleAdjustFee'
      ]
    }
  },
  computed: {
    getTotal() {
      let num = 0,
        weight = 0,
        price = 0
      this.assignSkus.forEach(sku => {
        const {
          buyNum,
          pieceWeight,
          itemSkuPrice,
          logisticsPrice = 0,
          commissionFee = 0,
          processFee = 0,
          promiseInterestSubsidyFee = 0,
          settleAdjustFee = 0,
          storageFee = 0
        } = sku
        if (buyNum) {
          num += buyNum * 1
          if (pieceWeight) {
            weight = this.plus(weight, this.times(pieceWeight, buyNum))
            if (itemSkuPrice) {
              price = this.plus(
                price,
                this.times(
                  this.plus(
                    itemSkuPrice * 1,
                    logisticsPrice * 1,
                    commissionFee * 1,
                    processFee * 1,
                    promiseInterestSubsidyFee * 1,
                    settleAdjustFee * 1,
                    storageFee * 1
                  ),
                  pieceWeight,
                  buyNum
                )
              )
            }
          }
        }
      })
      return {
        num,
        weight,
        price
      }
    },
    getIsOverWeight() {
      return this.getTotal.weight > this.toAssignSpu.assignWeightAmount / 10000
    },
    getIsOverPrice() {
      return this.getTotal.price > this.toAssignSpu.assignMoneyAmount / 100
    },
    getDisableEdit() {
      // 实提后的商品只能修改数量
      return this.assignSkus[0].realItemNum > 0
    },
    // 是否商家配送
    getIsMerchantDelivery() {
      // return this.toAssignSpu.logisticsWay === 2
      return true
    }
  },
  mounted() {
    const { mode, toAssignSpu, toEditSku } = this
    if (mode === 'add') {
      let {
        itemPrice,
        categoryId,
        valuationUnitWay
        // logisticsPrice
        // processFee,
        // storageFee,
        // commissionFee,
        // promiseInterestSubsidyFee,
        // settleAdjustFee
      } = toAssignSpu
      valuationUnitWay =
        valuationUnitWay === 0 ? this.optionsValuationUnitWay[0].value : valuationUnitWay
      this.assignSkus.push({
        valuationUnitWay,
        itemSkuPrice: itemPrice / 100,
        // logisticsPrice: logisticsPrice / 100,
        categoryId
        // processFee: processFee && processFee / 100,
        // storageFee: storageFee && storageFee / 100,
        // commissionFee: commissionFee && commissionFee / 100,
        // promiseInterestSubsidyFee: promiseInterestSubsidyFee && promiseInterestSubsidyFee / 100,
        // settleAdjustFee: settleAdjustFee && settleAdjustFee / 100
      })
    } else if (mode === 'edit') {
      const sku = this.getAssignSkusFormatedForDisplay([toEditSku])[0]
      if (sku.processFee) {
        this.fees.push('processFee')
      }
      if (sku.storageFee) {
        this.fees.push('storageFee')
      }
      if (sku.commissionFee) {
        this.fees.push('commissionFee')
      }
      if (sku.promiseInterestSubsidyFee) {
        this.fees.push('promiseInterestSubsidyFee')
      }
      if (sku.settleAdjustFee) {
        this.fees.push('settleAdjustFee')
      }
      if (sku.logisticsPrice) {
        this.fees.push('logisticsPrice')
      }
      this.assignSkus.push(sku)
    }
    this.getCategorySameLevelList(toAssignSpu.categoryId)
  },
  methods: {
    times: NP.times,
    plus: NP.plus,
    // 获取三级类目
    async getCategorySameLevelList(categoryId) {
      const { data, success } = await this.$get('items.getCategorySameLevelList', {
        categoryId
      })
      if (success && data[0].value) {
        this.categoryList = data[0].value
      }
    },
    // 指认
    async assign() {
      if (!this.check(this.assignSkus)) return // 校验数据合法性
      const itemParamList = this.getAssignSkusFormatedForInterface(this.assignSkus)
      const { mode } = this
      console.log(itemParamList)

      if (mode === 'add') {
        const { data, success } = await this.$post('trademanager.assignOrderItemForSeller', {
          assignOrderItemParam: {
            subBizOrderId: this.subOrderId,
            itemParamList
          }
        })
        if (success) {
          if (data[0].success) {
            this.refreshData()
            this.$message.success('指认成功')
            this.leave()
          } else {
            this.$message.error('指认失败，请稍后再试...')
          }
        }
      } else if (mode === 'edit') {
        const { data, success } = await this.$post('trademanager.modifyOrderItemForSeller', {
          modifyOrderItem: itemParamList[0]
        })
        console.log(data)
        if (success) {
          if (data[0].value) {
            this.refreshData()
            this.$message.success('编辑成功')
            this.leave()
          } else {
            this.$message.error('编辑失败，请稍后再试...')
          }
        }
      }
    },
    // 删除
    del(index) {
      this.assignSkus.splice(index, 1)
    },
    // 复制数据
    copy(sku) {
      this.assignSkus.push({ ...sku })
    },
    check(skus) {
      let msg
      for (let i = 0; i < skus.length; i++) {
        const {
          skuMaterial,
          skuSpecification,
          itemSkuPrice,
          steelMill,
          valuationUnitWay,
          buyNum,
          realItemNum,
          pieceWeight
        } = skus[i]
        let chn
        // if (!chn && !skuCategory) chn = '品名'
        if (!chn && !skuMaterial) chn = '材质'
        if (!chn && !skuSpecification) chn = '规格'
        if (!chn && !steelMill) chn = '钢厂'
        if (!chn && !(itemSkuPrice * 1)) chn = '单价'
        if (!chn && !valuationUnitWay) chn = '计量方式'
        if (!chn && !(pieceWeight * 1)) chn = '单件重'
        if (!chn && !(buyNum * 1)) chn = '数量'
        if (chn) {
          msg = `请输入第${i + 1}条明细的${chn}`
          break
        }
        if (!msg && buyNum * 1 < realItemNum) {
          msg = `第${i + 1}条明细, 数量不能小于已提的${realItemNum}件`
          break
        }
      }
      if (msg) {
        this.$message.warning(msg)
        return false
      } else {
        return true
      }
    },
    // 离开页面
    leave() {
      this.$emit('leave')
    },
    refreshData() {
      this.$emit('refreshData')
    },
    times100(data, val, key) {
      if (val && val !== '') {
        data[key] = val * 100
      }
    },
    // 指认、编辑时数据格式化。例如：String => Number, 重量、金钱位数转换
    getAssignSkusFormatedForInterface(skus) {
      return skus.map(sku => {
        const {
          skuMaterial,
          skuSpecification,
          itemSkuPrice,
          logisticsPrice,
          valuationUnitWay,
          pieceWeight,
          buyNum,
          assignId,
          categoryId,
          steelMill,
          bundleNo,
          processFee,
          storageFee,
          commissionFee,
          promiseInterestSubsidyFee,
          settleAdjustFee
        } = sku
        const skuCategory = (this.categoryList.find(cat => cat.id === categoryId) || {}).name
        let res = {
          skuMaterial,
          skuSpecification,
          itemSkuPrice: itemSkuPrice * 100,
          logisticsPrice: logisticsPrice * 100,
          valuationUnitWay,
          pieceWeight: pieceWeight * 10000,
          buyNum: buyNum * 1,
          buyWeight: this.times(pieceWeight, 10000, buyNum),
          skuCategory,
          assignId,
          categoryId,
          steelMill,
          bundleNo
        }
        this.times100(res, processFee, 'processFee')
        this.times100(res, storageFee, 'storageFee')
        this.times100(res, commissionFee, 'commissionFee')
        this.times100(res, promiseInterestSubsidyFee, 'promiseInterestSubsidyFee')
        this.times100(res, settleAdjustFee, 'settleAdjustFee')
        this.feesAll.forEach(key => {
          if (!this.fees.includes(key)) {
            res[key] = 0
          }
        })
        return res
      })
    },
    // 为展示页面格式化数据。例如：重量、金钱位数转换
    getAssignSkusFormatedForDisplay(skus) {
      return skus.map(sku => {
        const {
          itemSkuPrice,
          logisticsPrice,
          pieceWeight,
          processFee,
          storageFee,
          commissionFee,
          promiseInterestSubsidyFee,
          settleAdjustFee,
          id
        } = sku
        return {
          ...sku,
          itemSkuPrice: itemSkuPrice / 100,
          logisticsPrice: logisticsPrice / 100,
          pieceWeight: pieceWeight / 10000,
          assignId: id,
          processFee: processFee && processFee / 100,
          storageFee: storageFee && storageFee / 100,
          commissionFee: commissionFee && commissionFee / 100,
          promiseInterestSubsidyFee: promiseInterestSubsidyFee && promiseInterestSubsidyFee / 100,
          settleAdjustFee: settleAdjustFee && settleAdjustFee / 100
        }
      })
    },
    // 保留小数
    inputGetNumber(index, prop, retainNum = 0) {
      let val = (this.assignSkus[index][prop] || 0).toString()
      if (retainNum === 0) {
        // Integer
        val = val.replace(/[^\d]/g, '')
        val = Number.parseInt(val) // 优化体验，例：去除`01`前的0
      } else {
        // Float
        val = val.replace(/[^(\d|\.)]/g, '')
        if (val.includes('.')) {
          // 小数点只取一个
          const numArr = val.split('.')
          // 小数点开头自动补0
          val = `${numArr[0] || '0'}.${numArr[1].substring(0, retainNum)}`
        } else {
          val = Number.parseFloat(val) // 优化体验，例：去除`01`前的0
        }
      }
      // parseInt, parseFloat 空字符串为 NaN，放最后处理下，提防其他小坑
      val = Number.isNaN(val) ? 0 : val
      this.assignSkus[index][prop] = val
    },
    async handleMaterialSearch(str, cb, obj) {
      let p = this.categoryList.find(v => v.id === obj.categoryId)
      if (!p) {
        return cb([])
      }
      try {
        const { success, data } = await this.$get('essential.getTextureListByPName', {
          essentialInfoDTO: { pName: p.name, texture: str }
        })
        if (success && data && data[0] && data[0].textureResultList) {
          let mapList = data[0].textureResultList.map(v => ({ value: v.texture }))
          cb(mapList)
        } else {
          cb([])
        }
      } catch (e) {
        console.log(e)
        cb([])
      }
    },
    handleSelectChange(val) {
      this.feesAll.forEach(key => {
        if (!val.includes(key)) {
          this.assignSkus.forEach(item => {
            // delete item[key]
          })
        } else {
          this.assignSkus.forEach(item => {
            this.$set(item, key, item[key] || '')
          })
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.btn {
  width: 100px;
}
.operation-list {
  .icon {
    margin: 0 5px;
    &:hover {
      color: #efb96f;
    }
  }
}
.fees-select {
  margin-left: 10px;
}
</style>
<style lang="stylus">
.uncertain-order-assign .el-table .cell{
  height: 45px !important;
  line-height: 45px !important;
}
</style>
